import React from "react";
import Primitives from "../../../components/primitives";
const Trademark = () => (
  <Primitives.Flex>
    <img width="140px" height="auto" src={require("./scLogo.png")} />
  </Primitives.Flex>
);
export default Trademark;
